import $ from 'jquery';
import 'bootstrap/js/modal';
import { getLoginModalInstance } from 'application/login_modal';
import Menu from 'application/shared/menu';
import localStorageService from '~/app/javascript/src/services/local_storage_service';

const CONSTANTS = {
  undergraduate: 'Graduação',
  postgraduate: 'Pós-graduação',
  k12: 'Escola',
};

function switchPhoneNumberByLevel(level) {
  const root = $('#body-querobolsa');
  const $gradPhoneNumberHeader = $('.js-level-grad');
  const $posPhoneNumberHeader = $('.js-level-pos-grad');
  const $k12PhoneNumberHeader = $('.js-level-k12');

  if (level === CONSTANTS.undergraduate) {
    $gradPhoneNumberHeader.fadeIn('fast');
    $posPhoneNumberHeader.hide();
    $k12PhoneNumberHeader.hide();
    root.attr('data-theme', 'undergraduate');
  } else if (level === CONSTANTS.postgraduate) {
    $gradPhoneNumberHeader.hide();
    $posPhoneNumberHeader.fadeIn('fast');
    $k12PhoneNumberHeader.hide();
    root.attr('data-theme', 'postgraduate');
  } else if (level === CONSTANTS.k12) {
    $gradPhoneNumberHeader.hide();
    $posPhoneNumberHeader.hide();
    $k12PhoneNumberHeader.fadeIn('fast');
    root.attr('data-theme', 'school');
  }
}

function switchWhatsAppNumberByLevel(level) {
  const $gradWhatsAppNumberHeader = $('.js-level-grad-and-pos-whatsapp');
  const $k12WhatsAppNumberHeader = $('.js-level-k12-whatsapp');

  if (level === CONSTANTS.undergraduate || level === CONSTANTS.postgraduate) {
    $gradWhatsAppNumberHeader.fadeIn('fast');
    $k12WhatsAppNumberHeader.hide();
  } else if (level === CONSTANTS.k12) {
    $gradWhatsAppNumberHeader.hide();
    $k12WhatsAppNumberHeader.fadeIn('fast');
  }
}

$(window).on('load', () => {
  const defaultSimplifiedLevel = localStorageService.get('defaultSimplifiedLevel');

  if (defaultSimplifiedLevel) {
    switchWhatsAppNumberByLevel(defaultSimplifiedLevel);
    switchPhoneNumberByLevel(defaultSimplifiedLevel);
  }
});

$(document).on('search-form__level-switched', (_, level) => {
  let levelModifier;

  switch (level) {
    case 'k12':
      levelModifier = CONSTANTS.k12;
      break;
    case 'postgraduation':
      localStorageService.set('defaultSimplifiedLevel', 'Pós-graduação');
      levelModifier = CONSTANTS.postgraduate;
      break;
    default:
      localStorageService.set('defaultSimplifiedLevel', 'Graduação');
      levelModifier = CONSTANTS.undergraduate;
  }
  switchWhatsAppNumberByLevel(levelModifier);
  switchPhoneNumberByLevel(levelModifier);
});

_require([
  'bootstrap/popover',
], () => {
  const menu = new Menu(QB.rebrand === 'guia_do_estudante');
  const newPopoverTemplate = $($.fn.popover.Constructor.DEFAULTS.template).removeClass('grey-popover').addClass('new-popover');

  $('.js-user-menu-toggle').on('click', () => {
    if (menu.$menu.length) {
      menu.hideHelp();
      menu.showMenu();
    } else {
      const loginModal = getLoginModalInstance();
      loginModal.show();
    }
  });

  $('.js-help').on('click', () => {
    if (menu.helpIsHidden()) {
      menu.hideMenu();
      menu.showHelp();
    }
  });

  $('.js-how-it-works-menu').popover({
    html: true,
    trigger: 'hover',
    container: '.js-how-it-works-menu',
    content: $('.js-how-it-works-header').html(),
    template: newPopoverTemplate.clone().removeClass('new-popover').addClass('header-popover header-popover--alert header-popover--left'),
    placement: 'bottom',
  });
});
